import gql from 'graphql-tag';

export const getConstantsSystems = gql`
  query getConstantsSystems{
  getConstantsSystems{
    coinShareApp
    coinShareDeal
    coinShareOffer
    coinSharePromo
    coinReviewOffer
    coinReceiveShare
    walletConsumer
    walletUser
    shareOfferCoinMerchant
    shareAppCoinMerchant
    shareOfferCoinForConsumer
  }
}
`;
